<script>
import {
  iAccordion,
  iAccordionItem,
  iAccordionItemSizes,
} from '@inscribe/signal';
import DocumentRightDataBox from '@/V2/documents/document-view/DocumentRightDataBox';
import VerificationDetails from '@/V2/documents/document-view/verifications/VerificationDetails.vue';
import * as signalNames from '@/constants/signalNames';
import signalConfig from '@/constants/signalConfig';
import {
  VERIFICATION_RESULT_SORT_ORDER,
  ANALYST_GROUPS,
} from '@/constants/analyst-constants';
import { ANALYST_GROUPS_CONFIG } from '@/constants/analyst-config';
import InfoIcon from '@/V2/components/InfoIcon';

export default {
  components: {
    DocumentRightDataBox,
    iAccordion,
    iAccordionItem,
    VerificationDetails,
    InfoIcon,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
    currentVerificationComponent: {
      type: String,
    },
    currentVerification: {
      type: Object,
    },
  },
  data() {
    return {
      iAccordionItemSizes,
      signalConfig,
      viewFullGroup: false,
    };
  },
  computed: {
    hasLegacyVerifications() {
      return (
        this.legacyVerificationsGroup.riskLevels.reduce(
          (count, level) => count + level.verifications.length,
          0,
        ) > 0
      );
    },
    /**
     * these are legacy verifications
     */
    legacyVerificationsGroup() {
      const verificationsObject = this.document.verification;

      // we need to loop through the verificationsObject and group
      const riskLevels = [
        {
          key: 'Failed',
          verifications: [],
        },
        {
          key: 'Passed',
          verifications: [],
        },
      ];
      let failedCount = 0;
      let passedCount = 0;

      const addFinalObject = (finalObject) => {
        if (!finalObject.passed) {
          failedCount++;
          riskLevels[0].verifications.push(finalObject);
        } else {
          passedCount++;
          riskLevels[1].verifications.push(finalObject);
        }
      };

      [
        signalNames.NAME,
        signalNames.ADDRESS,
        signalNames.COMPANY,
        signalNames.ID_NUMBER,
        signalNames.STRINGS,
      ]
        .filter((key) => Object.keys(verificationsObject || {}).includes(key))
        .forEach((v) => {
          const verificationConfig = signalConfig[v];
          const verificationObject = verificationsObject[v];
          if (verificationObject.length) {
            verificationObject.forEach((vo) => {
              addFinalObject(
                this.getLegacyVerification(vo, verificationConfig),
              );
            });
          } else {
            addFinalObject(
              this.getLegacyVerification(
                verificationObject,
                verificationConfig,
              ),
            );
          }
        });

      // sort
      riskLevels.sort((r1, r2) => {
        return VERIFICATION_RESULT_SORT_ORDER[r1.key] >
          VERIFICATION_RESULT_SORT_ORDER[r2.key]
          ? 1
          : -1;
      });

      return {
        key: ANALYST_GROUPS.VERIFICATIONS,
        label: ANALYST_GROUPS_CONFIG[ANALYST_GROUPS.VERIFICATIONS].label,
        riskLevels,
        subtitle: `${failedCount} failed ${
          failedCount === 1 ? 'verification' : 'verifications'
        }`,
      };
    },
  },
  methods: {
    getLegacyVerification(object, config) {
      object.passed = object.verified;
      object.failed = !object.verified;
      object.result = object.verified ? 'Passed' : 'Failed';
      return {
        title: config.getTitle ? config.getTitle(object) : '',
        subtitle: object.verified ? object.matched : object.input,
        ...object,
      };
    },
    openFullGroup() {
      this.viewFullGroup = true;
      this.$nextTick(() => {
        this.$emit(
          'open-overlay',
          this.$refs.documentReviewGroupLegacy_verifications,
        );
      });
    },
    openItemDetails(verification) {
      this.$emit('set-verification', verification);
      this.$emit('set-verification-component', 'verification-details');
      this.$nextTick(() => {
        this.$emit('open-overlay', this.$refs.verificationDetails);
      });
    },
  },
};
</script>
<template>
  <template v-if="hasLegacyVerifications">
    <!-- Legacy verifications -->
    <i-accordion-item
      :mount-open="true"
      title="Document Content Checks"
      :no-background="true"
      :size="iAccordionItemSizes.LARGE"
      class="half-margin"
      data-testid="legacy-verifications-group"
    >
      <!-- title extra content -->
      <template #extra-title-content>
        <info-icon
          class="i-mr-4"
          title="Document Content Checks"
          description="Checks for the presence of specific document content."
        />
      </template>

      <!-- Legacy verifications group content -->
      <document-right-data-box
        :group="legacyVerificationsGroup"
        :compact-version="true"
        empty-state-title="No content checks detected"
        empty-state-subtitle="Document content checks will appear here"
        empty-state-icon="medium_file_alert_1"
        :show-loading-state="false"
        @show-item-details="openItemDetails"
        @view-all="openFullGroup(legacyVerificationsGroup)"
      ></document-right-data-box>
    </i-accordion-item>

    <!-- legacy verification full group -->
    <document-right-data-box
      v-if="viewFullGroup"
      ref="documentReviewGroupLegacy_verifications"
      :is-loading="false"
      :group="legacyVerificationsGroup"
      :compact-version="false"
      class="verification-group"
      @show-item-details="openItemDetails"
    ></document-right-data-box>

    <!-- legacy verification details -->
    <verification-details
      v-if="currentVerificationComponent === 'verification-details'"
      ref="verificationDetails"
      :verification="currentVerification"
    >
    </verification-details>
  </template>
</template>
